import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'console';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ReportService } from 'src/app/shared/services/report.service';

@Component({
  selector: 'app-paywebsuccess',
  templateUrl: './paywebsuccess.component.html',
  styleUrls: ['./paywebsuccess.component.css']
})
export class PaywebsuccessComponent implements OnInit {
  payGateData: any = []
  showTransactionPopup: boolean = true;
  constructor(
    private toastr: ToastrService
    , private datePipe: DatePipe
    , private regService: RegistrationService
    , private reportService: ReportService
    , private modalService: NgbModal
    , private masterService: MasterService
    , private authSvc: AuthenticationService
    , public activeModal: NgbActiveModal,
    public changeDetection: ChangeDetectorRef,
    private excelDownloadService: ExcelDownloadService, private activatedRoute: ActivatedRoute
    , private excelService: ExcelService
  ) { }

  ngOnInit(): void {
    this.payNow();
  }
  payNow() {
    let payRequestId = sessionStorage.getItem('payRequestId');
    this.regService.get(`registration/pay-gate/status/${payRequestId}`)
      .subscribe({
        next: (res: any) => {
          if (res.status === 'OK') {
            this.payGateData = res.data;
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
        }
      });
  }
  
  closeModal() {
    this.showTransactionPopup = false;
  }
}
